import { useMutation, useQueryClient } from "@tanstack/react-query";
import { api } from "@/lib/api-client";
import type { ScenarioCalendarOverride } from "@opus-dt/shared-types";

// Set do calendário do cenário (herdar/24-7/cópia). Invalida o detalhe do cenário
// (recarrega calendarOverride) + o preview leve, que passa a re-resolver as horas efetivas.
export function useSetScenarioCalendar(scenarioId: string) {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: (override: ScenarioCalendarOverride) =>
      api.patch(`/api/v1/scenarios/${scenarioId}/calendar`, override),
    onSuccess: () => {
      void qc.invalidateQueries({ queryKey: ["scenarios", scenarioId] });
    },
  });
}
